// Boot-time storage cleanup. **MUST be imported before `sessionStore`**
// (which means: as the first import in `main.tsx`). ES-module imports
// are hoisted and evaluated in source order, so the only way to run
// code before zustand's `persist` reads sessionStorage is to side-
// effect during a module that's imported earlier than the store.
//
// Persistence policy (matches the comment block in sessionStore.ts):
//   - F5 / Ctrl+R / Ctrl+F5 → wipe → fresh backend session
//   - Closing the tab / new tab → sessionStorage scope dies anyway
//   - Stripe roundtrip back to /checkout/success or /checkout/cancel
//     → preserve sessionStorage so the store rehydrates the in-flight
//     chat / artifacts and the user resumes paid-tier where they left off
//
// Also reaps any legacy `localStorage` entry from earlier builds that
// wrote there before we moved to sessionStorage.

if (typeof window !== "undefined") {
  try {
    window.localStorage.removeItem("revetra.session");
    const isStripeReturn =
      window.location.pathname === "/checkout/success" ||
      window.location.pathname === "/checkout/cancel" ||
      window.location.pathname === "/delivery/recover";
    if (!isStripeReturn) {
      window.sessionStorage.removeItem("revetra.session");
    }
  } catch {
    /* storage unavailable (private mode) — fine, nothing to clean. */
  }
}
